/* eslint-disable max-len */
import React from 'react';
import { isFlashPromotion } from 'domains/promotion/Promotion.types';
import { ByReferencesProps } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PriceOptionStep/AddPromotedReferece';
import { ApplyDiscountReferences } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PriceOptionStep/ApplyDiscountReferences';
import { ReferencesInput } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PriceOptionStep/ReferencesInput';
import { Flex } from 'UI';

const AddPromotedReferences = ({ promotion, setPromotion }: Readonly<ByReferencesProps>) => {
  const renderDiscount = !isFlashPromotion(promotion.promotionType) && promotion.promotionType !== 'BANNER';

  return (
    <Flex direction={'row'} data-cy={'by-references-row'}>
      <ReferencesInput promotion={promotion} setPromotion={setPromotion} />
      <Flex />
      {renderDiscount && <ApplyDiscountReferences promotion={promotion} setPromotion={setPromotion} />}
    </Flex>
  );
};

export default AddPromotedReferences;
